import React, { useState, useEffect } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PayPalSubscriptionButton = ({ planType, userEmail, userName, onSuccess, onError, onCancel }) => {
  const [clientId, setClientId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch PayPal client ID from backend
    const fetchConfig = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/paypal/config`);
        setClientId(response.data.client_id);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch PayPal config:', err);
        setError('PayPal is not configured');
        setLoading(false);
      }
    };
    fetchConfig();
  }, []);

  const createSubscription = async (data, actions) => {
    try {
      // Validate email before creating subscription
      if (!userEmail || userEmail.trim() === '') {
        throw new Error('Please enter your email address');
      }
      
      const response = await axios.post(`${API_URL}/api/paypal/create-subscription`, {
        plan_type: planType,
        email: userEmail,
        name: userName || 'User'
      });
      
      // Return the subscription ID for PayPal to process
      return response.data.subscription_id;
    } catch (err) {
      console.error('Failed to create subscription:', err);
      const errorMessage = err.response?.data?.detail || err.message || 'Failed to create subscription';
      if (onError) onError(new Error(errorMessage));
      throw err;
    }
  };

  const onApprove = async (data, actions) => {
    console.log('Subscription approved:', data);
    
    // The subscription is now active
    if (onSuccess) {
      onSuccess({
        subscriptionId: data.subscriptionID,
        planType: planType
      });
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (error || !clientId) {
    return (
      <div className="text-red-500 text-center py-4">
        {error || 'PayPal is not available'}
      </div>
    );
  }

  return (
    <PayPalScriptProvider 
      options={{ 
        clientId: clientId,
        vault: true,
        intent: 'subscription'
      }}
    >
      <PayPalButtons
        style={{
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'subscribe'
        }}
        createSubscription={createSubscription}
        onApprove={onApprove}
        onCancel={() => {
          console.log('Subscription cancelled by user');
          if (onCancel) onCancel();
        }}
        onError={(err) => {
          console.error('PayPal error:', err);
          if (onError) onError(err);
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalSubscriptionButton;
